export default __webpack_public_path__ + "static/media/checkmark.702a634a.svg";